import React, { useState, FC } from 'react'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { WidgetLayout } from '../../../lib/widget-layout'
import { Button } from '../../../common/components/Button'
import useText from '../../../common/hooks/useText'
import { CompanySearchWidget } from '../../../support/components/company-search-widget'
import OrganisationsTable from '../../../common/features/tables/OrganisationsTable'
import {
    useCompanyGetAllOrFilteredQuery,
    CompanyGetAllOrFilteredApiArg,
    useCompanyCreateCompanyMutation,
    Company,
    usePartnerGetAllAllQuery,
} from '../../../common/redux/api/web-api'
import { CreateOrganisationModal } from '../../../support/components/create-organisation-modal'

export const OrganisationsPage: FC = () => {
    const text = useText()
    const [createOrganisationModalIsOpen, setOrganisationModalIsOpen] = useState(false)
    const [filter, setFilter] = useState<CompanyGetAllOrFilteredApiArg>({})

    const { data: partners = [] } = usePartnerGetAllAllQuery({ excludeOrphans: false })
    const { data: companies = [], isLoading } = useCompanyGetAllOrFilteredQuery(
        {
            ...filter,
            numberOfItems: 100,
        },
        { refetchOnMountOrArgChange: true }
    )
    const [createCompany] = useCompanyCreateCompanyMutation()

    const onClear = () => {
        setFilter({})
    }

    const onCreateCompany = (company: Company) => {
        return createCompany({ company }).unwrap()
    }

    return (
        <PageLayoutContainer>
            <CompanySearchWidget onSearch={setFilter} onClear={onClear} />

            <WidgetLayout
                title={text('lblOrganisations')}
                headerButtons={[
                    <Button
                        label={text('btnCreate')}
                        onClick={() => setOrganisationModalIsOpen(true)}
                        data-testid="btn-create"
                    />,
                ]}
            >
                {companies.length > 0 ? (
                    <span className="heading5">{text('msgOrganisationsFound', { amount: companies.length })}</span>
                ) : null}

                <OrganisationsTable data={companies} loading={isLoading} />
            </WidgetLayout>

            <CreateOrganisationModal
                isOpen={createOrganisationModalIsOpen}
                onClose={() => setOrganisationModalIsOpen(false)}
                partners={partners}
                onSubmit={onCreateCompany}
            />
        </PageLayoutContainer>
    )
}
